import React, { useEffect, useState } from "react";
// import { AOS } from "aos";
import person from "../../assests/images/getInvolved/Person.png";
import $ from "jquery";
import { useSelector } from "react-redux";
import gsap from "gsap/all";
import { ScrollTrigger } from "gsap/all";
import "../../assests/css/whygetinvolve.css";

const WhyToGetInvolved = () => {
	const { giverData } = useSelector((state) => state.givers);
	const [bg, setbg] = useState("");
	const [check, setCheck] = useState();

	useEffect(() => {
		setTimeout(() => {
			// AOS.init();
		}, 1000);
		gsap.registerPlugin(ScrollTrigger);
		const cards = gsap.utils.toArray(".gry_box");

		cards.forEach((card, index) => {
			const tween = gsap.to(card, {
				scrollTrigger: {
					trigger: card,
					start: () => `top bottom-=100`,
					end: () => `top top+=40`,
					scrub: true,
					// markers: true,
					invalidateOnRefresh: true,
				},
				ease: "none",
				scale: () => 1 - (cards.length - index) * 0.025,
			});

			ScrollTrigger.create({
				trigger: card,
				start: "top top",
				pin: true,
				pinSpacing: false,
				id: "pin",
				end: "max",
				// markers: true,
				invalidateOnRefresh: true,
			});
		});
		// $(window).scroll(function () {
		// 	console.log(window.location.hash);
		// 	//   if (window.location.hash == "#/givers" || window.location.hash == "") {
		// 	var scroll = $(document).scrollTop();
		// 	if (scroll > 800 && scroll < 200) {
		// 		console.log(scroll);
		// 		let maxScroll = 200;
		// 		let newS = maxScroll - scroll;
		// 		let percentage = (newS / maxScroll) * 100;
		// 		let newTranslate = 100 * (percentage / 100);
		// 		setbg(newTranslate);
		// 		setCheck(newTranslate);
		// 	}
		// 	//   }
		// });
	}, [bg]);

	return (
		<div className="WhyToGetInvolved">
			<div className="container">
				<div className="row">
					<div className="col-lg-5">
						<div className="text-wrapper">
							<p data-aos="fade-right" className="heading">
								Our Community of
								<br />
								benefacto
							</p>
							<p data-aos="fade-left" className="text mt-4">
								Quam vulputate dignissim suspendisse in est ante in.
								Pellentesque massa placerat duis ultricies lacus sed turpis
								tincidunt. Risus nec feugiat in fermentum posuere urna nec
								tincidunt praesent. Vitae nunc sed velit dignissim sodales ut eu
								sem. Magna fermentum iaculis eu non diam phasellus vestibulum
								lorem. Elit sed vulputate mi sit. Phasellus faucibus scelerisque
								eleifend donec pretium. Nunc lobortis mattis aliquam faucibus
								purus in massa. Lacus sed viverra tellus in hac habitasse platea
								dictumst. Vitae auctor eu augue ut lectus arcu bibendum at
								varius.
							</p>
						</div>
					</div>
					<div className="col-lg-7">
						<div className="row">
							{/* <div className="row py-5" style={{ height: "100vh" }}>
								<div className="col-lg-6"></div>
								<div className="col-lg-6">
									<div>
										<div className="containers pt-5 mt-5">
											<div className="cards">
												<div className="card cardt" style={{ top: "40px" }}>
													1
												</div>
												<div className="card cardt" style={{ top: "45px" }}>
													2
												</div>
												<div className="card cardt" style={{ top: "50px" }}>
													3
												</div>
												<div className="card cardt" style={{ top: "55px" }}>
													4
												</div>
												<div className="card cardt" style={{ top: "60px" }}>
													5
												</div>
											</div>
										</div>
										<div className="container2"></div>
									</div>
								</div>
							</div> */}
							<div className="col-lg-12 box_wrapper">
								{giverData?.data?.benefits?.data?.map((item, index) => {
									return (
										<>
											<div
												key={index}
												className="gry_box mb-4"
												style={{ top: "40px" }}
											>
												<div className="row">
													<div className="col-lg-9">
														<img src={person} alt="person get involved" />
													</div>
													<div className="col-lg-3">
														<p className="number">
															{index > 10 ? index : `0${index + 1}`}
														</p>
													</div>
													<div className="col-lg-12 mt-5 mb-2">
														<p className="benefits">{item?.title}</p>
														<p className="text mb-0">{item?.description}</p>
													</div>
												</div>
											</div>
										</>
									);
								})}
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default WhyToGetInvolved;
